import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import CardComponent from 'Component/Level/Card';

export default function EarlyRemoveThreePreBoosterTask(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    taskData.cards.forEach(cardID => {
        const card = system.getCardByID(cardID);
        card.getComponent(CardComponent).animating = true;
    });


}
